webpackJsonp([200718656109232],{

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Template(_ref) {
	  var data = _ref.data;
	  var markdownRemark = data.markdownRemark;
	  var frontmatter = markdownRemark.frontmatter,
	      html = markdownRemark.html;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "content-wrapper" },
	    _react2.default.createElement(
	      "div",
	      { className: "row" },
	      _react2.default.createElement(
	        "div",
	        { className: "columns medium-12" },
	        _react2.default.createElement(
	          "section",
	          { className: "nameCategory" },
	          _react2.default.createElement(
	            "div",
	            { className: "card-caption large" },
	            _react2.default.createElement(
	              "div",
	              { className: "card-caption__img-wrapper" },
	              _react2.default.createElement("img", { src: frontmatter.icon, alt: "\u0412\u044B\u0434\u0430\u0447\u0430 \u043E\u0440\u0434\u0435\u0440\u0430" })
	            ),
	            _react2.default.createElement(
	              "h4",
	              { className: "card-caption__name" },
	              frontmatter.title
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: frontmatter.dir_url },
	            _react2.default.createElement(
	              "button",
	              { type: "button", className: "button button-lg button-arrow-left" },
	              frontmatter.dir_url_title
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "columns medium-9" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: html } }),
	        frontmatter.captionTitle && _react2.default.createElement(
	          "section",
	          { className: "titleStep" },
	          _react2.default.createElement(
	            "ul",
	            { className: "titleStep__list transportAndDriving" },
	            _react2.default.createElement(
	              "li",
	              { className: "list__caption" },
	              frontmatter.captionTitle
	            ),
	            frontmatter.captionText && _react2.default.createElement(
	              "li",
	              { className: "list__content" },
	              frontmatter.captionText
	            )
	          )
	        )
	      ),
	      frontmatter.itemList && _react2.default.createElement(
	        "div",
	        { className: "columns medium-9" },
	        _react2.default.createElement(
	          "div",
	          { className: "service" },
	          _react2.default.createElement(
	            "div",
	            { className: "steps-wrapper" },
	            frontmatter && frontmatter.itemList && frontmatter.itemList.map(function (test, index) {
	              return _react2.default.createElement(
	                "ul",
	                { key: test[0], className: "steps transportAndDriving" },
	                _react2.default.createElement(
	                  "li",
	                  { className: "steps__caption" },
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    index + 1
	                  ),
	                  test[0]
	                ),
	                test[1] && _react2.default.createElement(
	                  "li",
	                  { className: "steps__content" },
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    test[1]
	                  )
	                )
	              );
	            }),
	            frontmatter.lastItemCaption && _react2.default.createElement(
	              "ul",
	              { className: "lastStep transportAndDriving" },
	              _react2.default.createElement(
	                "li",
	                { className: "lastStep__caption" },
	                _react2.default.createElement("span", null),
	                frontmatter.lastItemCaption
	              ),
	              frontmatter.lastItemText && _react2.default.createElement(
	                "li",
	                { className: "lastStep__content" },
	                frontmatter.lastItemText
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-usluga-template-js-3a88b2a1acfd81e8cd20.js